const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Normalize to the API host root. If a full /api/v1 URL is provided, strip the trailing path.
const API_ROOT = rawBaseUrl.replace(/\/api\/v1\/?$/i, '');
const API_V1_ROOT = `${API_ROOT}/api/v1`;

export { API_ROOT, API_V1_ROOT };
